import { ApiService } from 'src/app/services/api.service';

import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-subscription-schedule-selection',
  templateUrl: './subscription-schedule-selection.component.html',
  styleUrls: ['./subscription-schedule-selection.component.scss'],
})
export class SubscriptionScheduleSelectionComponent implements OnInit {
  @Input() stop;
  @Input() day = 'Lunes';
  @Input() dotw = 1;
  @Input() type = 'go';
  result;
  user;
  schedules;

  constructor(private apiService: ApiService, private modalController: ModalController) {}

  ngOnInit() {
    this.getTrips();
  }

  getTrips() {
    this.apiService
      .getData('trips/' + this.stop.id + '?type=' + this.type + '&dotw=' + this.dotw)
      .then((res) => {
        console.log('schedules: ', res);
        this.schedules = res.data.trips;
      })
      .finally(() => {});
  }

  closeModal() {
    this.modalController.dismiss();
  }

  select(selectedSchedule) {
    this.modalController.dismiss({
      schedule: selectedSchedule,
    });
  }
}
